import { Inbox, LayoutDashboard, Send } from "lucide-react";
import {
  flattenPortalNavigation,
  type CommandPaletteQuickAction,
  type PortalNavSection,
} from "@pulse-business-ai/portal-shell";
import { NAV_SECTIONS } from "@/core/router/navConfig";
import { ADMIN_ROLES, OPERATOR_ROLES } from "@/shared/ui/RoleGuard";

function hubSectionId(label: string): string {
  return label.toLowerCase().replace(/\s+/g, "-");
}

/**
 * Maps route paths to role requirements.
 * Items NOT listed here are shown to everyone.
 */
const ROUTE_ROLE_GATES: Record<string, readonly string[]> = {
  "/governance": ADMIN_ROLES,
  "/costs": OPERATOR_ROLES,
  "/fleet/reporting": OPERATOR_ROLES,
};

/** Grouped sidebar for PortalShell (parallel review plan Team C). */
export const HUB_NAVIGATION_SECTIONS: PortalNavSection[] = NAV_SECTIONS.map((section) => ({
  id: hubSectionId(section.label),
  label: section.label,
  items: section.items.map((item) => ({
    href: item.to,
    name: item.label,
    icon: item.icon,
    ...(ROUTE_ROLE_GATES[item.to] ? { requiredRoles: ROUTE_ROLE_GATES[item.to] } : {}),
  })),
}));

/**
 * Returns nav sections filtered to only items the given user roles can access.
 * Items without `requiredRoles` are always included.
 * Sections whose items are all filtered out are omitted entirely.
 */
export function getFilteredNavSections(userRoles: string[]): PortalNavSection[] {
  return HUB_NAVIGATION_SECTIONS
    .map((section) => ({
      ...section,
      items: section.items.filter((item) => {
        const gated = (item as unknown as Record<string, unknown>).requiredRoles as
          | readonly string[]
          | undefined;
        if (!gated) return true;
        return userRoles.some((r) => gated.includes(r));
      }),
    }))
    .filter((section) => section.items.length > 0);
}

/** @deprecated Prefer HUB_NAVIGATION_SECTIONS; kept for callers expecting a flat list. */
export const HUB_NAVIGATION = flattenPortalNavigation(HUB_NAVIGATION_SECTIONS);

export const HUB_COMMAND_PALETTE_QUICK_ACTIONS: CommandPaletteQuickAction[] = [
  { name: "Today", href: "/", icon: LayoutDashboard },
  { name: "Inbox", href: "/inbox", icon: Inbox },
  { name: "Dispatch", href: "/dispatch", icon: Send },
];
